import { render, staticRenderFns } from "./VCandidateProfile.vue?vue&type=template&id=3cd95426&scoped=true&lang=pug"
import script from "./VCandidateProfile.vue?vue&type=script&lang=ts"
export * from "./VCandidateProfile.vue?vue&type=script&lang=ts"
import style0 from "./VCandidateProfile.vue?vue&type=style&index=0&id=3cd95426&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd95426",
  null
  
)

/* custom blocks */
import block0 from "./CandidatesProfile.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FTemplate%2Fviews%2FCandidates%2FProfile%2FVCandidateProfile.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports